import { configure } from "mobx";
import { BrowserDetector } from "../../util/browser/BrowserDetector";

export function configureMobX() {
	/* mobx configuration */
	configure({
		enforceActions: "observed",
		useProxies: BrowserDetector.isThisALegacyBrowser() ? "never" : "always",

		//Only enable Mobx idioms in development builds; Uncomment them if you want a lot of console.warns...
		/*computedRequiresReaction: isDevelopment && isDevelopment,
        reactionRequiresObservable: isDevelopment && isDevelopment,
        observableRequiresReaction: isDevelopment && isDevelopment,*/
	});
}
